import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsSkipForward2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M4.5 4l5 2.857V4.5h2v7h-2V9.143L4.5 12z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsSkipForward2
